import React from 'react';

import Navbar from '../src/Component/Navbar';
import Footer from '../src/Component/Footer';
import Gallery from '../src/Component/Gallery';
import OurServices from "../src/Component/OurServices";
import Contact from "../src/Component/Contact";
import {AboutUs}  from "./Component/Aboutus";

// ✅ Only import Routes and Route here
import { Routes, Route } from "react-router-dom";
import Home from "../src/Component/Home";
import WellnessSection from "./Component/WellnessSection";
import TravelPackages from "./Component/TravelPackages";
import OurActivity from "./Component/OurActivity";
import HerbalProductList from "./Component/HerbalProductList";
import Bank from "./Component/Bank";
import {FabricStore} from "./Component/FabricStore";
import AboutDetails from "./Component/AboutDetails";
import MaskMuseum from "./Component/MaskMuseum";

import BeachParty from "./Component/BeachParty";
import Bonfire from "./Component/Bonfire";
import InstrumentalMusic from "./Component/InstrumentalMusic";
import Fireworks from "./Component/Fireworks";
import DJMusic from "./Component/DJMusic";
import TripadvisorPopupButton from "./Component/TripadvisorPopupButton";

const App = () => {
    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/gallery" element={<Gallery />} />

                <Route path="/services" element={<OurActivity />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/wellness" element={<WellnessSection />} />
                <Route path="/travel" element={<TravelPackages />} />
                <Route path="/ayurveda" element={<OurServices />} />
                <Route path="/tea" element={<HerbalProductList />} />
                <Route path="/bank" element={<Bank/>} />
                <Route path="/fabric" element={<FabricStore/>} />
                <Route path="/about-details" element={<AboutDetails />} />
                <Route path="/masks" element={<MaskMuseum />} />
                <Route path="/beach-party" element={<BeachParty />} />
                <Route path="/bonfire" element={<Bonfire />} />
                <Route path="/instrumental-music" element={<InstrumentalMusic />} />
                <Route path="/dj-music" element={<DJMusic />} />
                <Route path="/fireworks" element={<Fireworks />} />




            </Routes>
            <Footer />
            <TripadvisorPopupButton />
        </>
    );
};

export default App;
